import { Outlet } from "react-router";
import { GenericBoundary } from "~/components/error-boundaries/error-boundaries";

export const ErrorBoundary = GenericBoundary;
export default function Events() {
  return <Outlet />;
}
